// Module
var code = "<i class=\"ml-1 icon icon-sorting--default icon-sorting\" data-bind=\"css: {\n  'icon-sorting--asc': asc && show(),\n  'icon-sorting--desc': !asc() && show(),\n  'icon-sorting--active': show()\n}\"></i>\n";
// Exports
module.exports = code;